/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { AuthorizeGiftClaimResponse, AuthorizeGiftClaimVars } from '../openapi-types.gen.js';

export type { AuthorizeGiftClaimResponse, AuthorizeGiftClaimVars } from '../openapi-types.gen.js';

export const useAuthorizeGiftClaim = createMutationHook<AuthorizeGiftClaimVars, AuthorizeGiftClaimResponse, unknown>({
  specName: 'useAuthorizeGiftClaim',
  path: '/v1/gifts/claim/authorize',
  method: 'POST',
  resolveUrl: (vars: AuthorizeGiftClaimVars) => `/v1/gifts/claim/authorize`,
  buildBody: (vars: AuthorizeGiftClaimVars) => ({ opaqueId: vars.opaqueId, destinationWalletPubkey: vars.destinationWalletPubkey }),
  parseResponse: (raw: unknown): AuthorizeGiftClaimResponse => raw as AuthorizeGiftClaimResponse,
  
  
  
});
